module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/coj_e-1-422be946622b67036fb94ea7e6fcfa46.jpg";